export default __webpack_public_path__ + "static/Blind-angels-series-trailer-thumbnail-be20addcfc838b3281536cf4bf732d73.png";